/* Built In Imports */
import React from 'react';
/* External Imports */
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
/* Styles */
import OtherSt from '@moms/styleData/OtherSt';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainHeading = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 2) return null;
  const titleSection = sectionContent[0];

  return (
    <Box
      maxW="1090px"
      mx={{ md: 'auto' }}
      display={{ md: 'flex' }}
      px={{ base: '1rem', md: '0' }}
      width={{ md: '90%', xl: '100%' }}
      flexDirection="column"
      gap="8px"
    >
      <Text {...OtherSt[lang]?.titleText} as="span">
        {titleSection?.titleText || 'Other'}
      </Text>
      <Text
        {...OtherSt[lang]?.titleSubtext}
        as={'span'}
        ml={{ base: '.5rem', md: '0' }}
      >
        {titleSection?.titleSubtext || 'Large Scale Movements'}
      </Text>
      <Text
        {...OtherSt[lang]?.additionalTextLine}
        mt={{ base: '.2rem', md: '0' }}
      >
        {titleSection?.additionalTextLine || 'By Sadhguru'}
      </Text>
    </Box>
  );
};

const MainLayout = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 2) return null;

  return (
    <Box
      maxW="1020px"
      ml={{ base: '0', md: 'auto' }}
      mr={{ base: '0', md: 'auto' }}
      mt={{ base: '2rem', md: '4.5rem' }}
    >
      {/* Use Slider for base, Flex for md+ */}
      <PhoneSlider
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />

      {/* Keep original layout for md+ */}
      <MdFlex region={region} lang={lang} sectionContent={sectionContent} />
    </Box>
  );
};

const PhoneSlider = ({ region, lang, sectionContent }) => {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.1,
    variableWidth: true,
    slidesToScroll: 1,
    customPaging: i => (
      <Box
        width={{ base: '11.39px' }}
        height={{ base: '11.39px' }}
        borderRadius="50%"
        // mt={{ base: '2rem', lg: '4rem' }}
        marginRight="1rem"
        bgColor=" #FFFFFF33"
        transition="background-color 0.3s, opacity 0.3s"
        css={{
          '.slick-active &': {
            backgroundColor: '#EC1C2D',
            opacity: '1',
          },
        }}
        _hover={{ bgColor: '#08152D' }}
      />
    ),
  };
  if (!sectionContent || sectionContent.length < 2) return null;
  const cardSection = sectionContent[1]?.cards || [];

  return (
    <Box display={{ base: 'block', md: 'none' }}>
      <Slider {...sliderSettings}>
        {cardSection.map((card, index) => (
          <Box
            key={index}
            w={{
              base: '306px !important',
            }}
            textAlign="center"
            maxW="306px"
            ml={{ base: '1rem', md: 'auto' }}
            mr={{ base: '0', md: 'auto' }}
          >
            <Box
              width="306px"
              height="302px"
              pos={'relative'}
              bgImage={`url(${card.thumbnail?.url})`}
              bgSize="cover"
              bgPosition="center"
            >
              <Box
                width={{ base: '133px' }}
                height={{ base: '133px' }}
                pos={'absolute'}
                left={'29%'}
                bottom={'-22%'}
              >
                {/* use that mobileImage here from sectioncontent */}

                <Image
                  width={'100%'}
                  height={'100%'}
                  src={card.mobileImage?.url || 'fallback-image-url.jpg'}
                  alt={card.mobileImage?.alt || 'Image description'}
                />
              </Box>
            </Box>

            <Text
              {...OtherSt[lang]?.TextLine1}
              mt="6.5rem"
              // px={{ base: '4.8rem', md: '4rem' }}
              px={
                index === 0
                  ? { base: '4.8rem', md: '4rem' }
                  : { base: '0', md: '4rem' }
              }
            >
              {card.title}
            </Text>
            <Link href={card.buttonLink} isExternal>
              <Button
                mt="2rem"
                width="fit-content"
                height="48px"
                bgColor="transparent"
                border="none"
                borderBottom="1px solid rgba(236, 28, 45, 1)"
                _hover={{ textDecoration: 'none' }}
                borderRadius="0"
                py="10px"
                ps="8px"
                pe="0"
                display="flex"
                justifyContent="space-between"
                gap="8px"
                mx="auto"
                color="#fff"
              >
                <Text {...OtherSt[lang]?.TextLine2}>{card.buttonText}</Text>
                <ChevronRightIcon width="32px" height="32px" padding="3px" />
              </Button>
            </Link>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

const MdFlex = ({ region, lang, sectionContent }) => {
  if (!sectionContent || sectionContent.length < 2) return null;

  const cardSection = sectionContent[1]?.cards || [];
  return (
    <Flex
      gap={{ md: '2rem', lg: '5rem' }}
      justifyContent="center"
      alignItems={{ md: 'center', lg: 'baseline' }}
      flexWrap={{ md: 'wrap', xl: 'nowrap' }}
      display={{ base: 'none', md: 'flex' }}
    >
      {cardSection.map((card, index) => (
        <Box key={index} textAlign="center" maxW="306px">
          <Box
            width="306px"
            height="302px"
            bgImage={`url(${card.thumbnail?.url})`}
            bgSize="cover"
            bgPosition="center"
            pos={'relative'}
          >
            <Box
              width={{ base: '133px' }}
              height={{ base: '133px' }}
              pos={'absolute'}
              left={'29%'}
              bottom={'-22%'}
            >
              {/* use that mobileImage here from sectioncontent */}
              <Image
                width={'100%'}
                height={'100%'}
                src={card.mobileImage?.url || 'fallback-image-url.jpg'}
                alt={card.mobileImage?.alt || 'Image description'}
              />
            </Box>
          </Box>
          <Text
            {...OtherSt[lang]?.TextLine1}
            mt={{ md: '7rem' }}
            // px="4rem"
            px={index === 2 ? 0 : '4rem'}
          >
            {card.title}
          </Text>
          <Link
            _hover={{ textDecoration: 'none' }} // Ensure no underline on hover as well
            textDecoration="none"
            href={card.buttonLink}
            isExternal
          >
            <Button
              mt={{ md: '2rem' }}
              width="fit-content"
              height="48px"
              bgColor="transparent"
              border="none"
              borderBottom="1px solid rgba(236, 28, 45, 1)"
              _hover={{
                textDecoration: 'none',
                border: 'none',
                borderBottom: '1px solid #636EFE',
              }}
              _focus={{
                textDecoration: 'none',
                border: 'none',
                borderBottom: '1px solid #636EFE',
              }}
              _active={{
                textDecoration: 'none',
                border: 'none',
                borderBottom: '1px solid #636EFE',
              }}
              _focusVisible={{
                boxShadow: 'none',
                textDecoration: 'none',
                border: 'none',
                borderBottom: '1px solid #636EFE',
              }}
              borderRadius="0"
              py="10px"
              ps="8px"
              pe="0"
              display="flex"
              justifyContent="space-between"
              gap="8px"
              mx={{ base: 'auto', lg: 'auto' }}
              color="#fff"
            >
              <Text {...OtherSt[lang]?.TextLine2}>{card.buttonText}</Text>
              <ChevronRightIcon width="32px" height="32px" padding="3px" />
            </Button>
          </Link>
        </Box>
      ))}
    </Flex>
  );
};

const OtherMovements = ({ sectionContent, lang, region }) => {
  if (!sectionContent || sectionContent.length < 2) return null;

  return (
    <Box
      pt={{ base: '6rem', md: '10rem' }}
      pb={{ base: '10rem', md: '2rem' }}
      borderBottom={'2px solid #ffffff33'}
    >
      {/* Headings Box */}
      <MainHeading
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />

      {/* Image Content Main Box */}
      <MainLayout region={region} lang={lang} sectionContent={sectionContent} />
    </Box>
  );
};

export default OtherMovements;
